import { MERCHANT_ID_REGEXP } from "./constants";
import { message } from "antd";
import { saveAs } from "file-saver"
const queryString = require('query-string')

export function download_resource(url : string){
  let file_path = typeof(__PROXY_URL__) != 'undefined' ? `${__PROXY_URL__}${url}` : url
  let a = document.createElement('a')
  a.href = file_path
  a.download = ''
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export const downloadCsv = (csv: string, filename: string) => {
  let csv_blob = new Blob([csv],{ type: 'data:text/csv;charset=utf-8'})
  saveAs(csv_blob, `${filename}.csv`)
}

export function merchantIdFromProps(props: any) {
  if (
    props.location &&
    props.location.pathname &&
    MERCHANT_ID_REGEXP.test(props.location.pathname)
  ) {
    let id = parseInt(MERCHANT_ID_REGEXP.exec(props.location.pathname)[1]);
    if (!isNaN(id))
      return id;
  }
  return null
}

export const  generateQueryString = (args:any) => {
  //Generates query string based on Object hash
  let query_string = queryString.stringify(args, {arrayFormat: 'bracket'})
  return query_string
}

export const parseQueryString= (query_string:string) => {
  //Generates Query params object from query string
  let query_params = queryString.parse(query_string, {arrayFormat: 'bracket'})
  return query_params
}

export const copyUrlToClipboard = () => {
  var textArea = document.createElement("textarea");
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';


  textArea.value = location.href;

  document.body.appendChild(textArea);

  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    message.config({
      top: 70,
    });
    if(successful){
      message.success(
        'Copied URL to clipboard.'
      );
    }
    else{
      message.error('Failed to copy URL to clipboard.')
    }

  } catch (err) {
    message.error('Failed to copy URL to clipboard.')
  }

  document.body.removeChild(textArea);
}

export const LocalStorageMock = (function() {
  var store = {} as any;
  return {
    getItem: function(key: any) {
      return store[key];
    },
    setItem: function(key: any, value: any) {
      store[key] = value.toString();
    },
    clear: function() {
      store = {};
    },
    removeItem: function(key: any) {
      delete store[key];
    }
  };
})()


export const hostedMerchants = [
  {
    merchant_id: 3555,
    launch_date: "2020-09-16",
  },
  {
    merchant_id: 246,
    launch_date: "2020-01-29",
  },
  {
    merchant_id: 485,
    launch_date: "2020-10-22",
  },
  {
    merchant_id: 3762,
    launch_date: "2020-10-26",
  },
  {
    merchant_id: 2668,
    launch_date: "2020-02-06",
  },
  {
    merchant_id: 2460,
    launch_date: "2019-07-12",
  },
  {
    merchant_id: 221,
    launch_date: "2019-10-23",
  },
  {
    merchant_id: 5179,
    launch_date: "2020-01-29",
  },
  {
    merchant_id: 5697,
    launch_date: "2020-07-14",
  },
  {
    merchant_id: 3415,
    launch_date: "2020-05-06",
  },
  {
    merchant_id: 3552,
    launch_date: "2020-06-18",
  },
  {
    merchant_id: 236,
    launch_date: "2020-09-28",
  },
  {
    merchant_id: 2405,
    launch_date: "2020-05-14",
  },
  {
    merchant_id: 2701,
    launch_date: "2020-10-24",
  },
  {
    merchant_id: 5114,
    launch_date: "2020-09-21",
  },
  {
    merchant_id: 2419,
    launch_date: "2020-06-15",
  },
  {
    merchant_id: 4417,
    launch_date: "2020-02-28",
  },
  {
    merchant_id: 2015,
    launch_date: "2020-08-20",
  },
  {
    merchant_id: 550,
    launch_date: "2020-09-01",
  },
  {
    merchant_id: 233,
    launch_date: "2020-07-02",
  },
  {
    merchant_id: 2207,
    launch_date: "2020-01-24",
  },
  {
    merchant_id: 2415,
    launch_date: "2020-06-16",
  },
  {
    merchant_id: 973,
    launch_date: "2020-08-12",
  },
  {
    merchant_id: 5698,
    launch_date: "2020-07-14",
  },
  {
    merchant_id: 2143,
    launch_date: "2019-08-05",
  },
  {
    merchant_id: 2432,
    launch_date: "2020-06-02",
  },
];



// WEBPACK FOOTER //
// ./client/modules/common/utils.tsx